import { useCallback } from 'react';
import { useQueryClient } from 'react-query';

import { getQueryKey } from 'hb-react/shared/apps/News/NewsPublished/utils/queryUtils';
import toggleLike from 'hb-react/shared/components/DesignSystem/Reactions/utils/toggleLike';
import type { ToggleLike } from 'hb-react/shared/components/DesignSystem/Reactions/utils/toggleLike';

export interface UseToggleLikeProps {
  toggleLikeHandler?: ToggleLike;
}

export type UseTogglePostLike = (UseToggleLikeProps) => {
  togglePostLike: ToggleLike;
};

// Wrapper around toggleLike that clears the query cache for the post
export const useTogglePostLike: UseTogglePostLike = ({
  toggleLikeHandler = toggleLike,
} = {}) => {
  const queryClient = useQueryClient();

  const togglePostLike = useCallback(
    ({ userId, likeId, likeableId, type }) =>
      toggleLikeHandler({ userId, likeId, likeableId, type }).then((data) => {
        queryClient.invalidateQueries({
          queryKey: getQueryKey(likeableId),
        });

        return data;
      }),
    [queryClient, toggleLikeHandler],
  );

  return { togglePostLike };
};
